import React from 'react';

export const SuccessIcon = () => (
  <div className="relative w-6 h-6 flex items-center justify-center">
    <div className="absolute inset-0 bg-gradient-to-b from-[#69E87A] to-[#0CCA26] rounded-lg shadow-lg" style={{ boxShadow: '0px 0px 24px -4px rgba(13, 217, 41, 0.12), 0px 0px 16px -4px rgba(13, 217, 41, 0.08), 0px 0px 8px -6px rgba(13, 217, 41, 0.04)' }}></div>
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="relative">
      <path d="M12.0007 21.3333C17.1673 21.3333 21.334 17.1666 21.334 12C21.334 6.83331 17.1673 2.66665 12.0007 2.66665C6.83398 2.66665 2.66699 6.83331 2.66699 12C2.66699 17.1666 6.83398 21.3333 12.0007 21.3333Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8.66602 12L10.7527 14.0866L15.3327 9.51329" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  </div>
);
